const EMAIL_REG_EXP = /\S+@\S+\.\S+/;
const PHONE_REG_EXP = /\d{9}/;

export const isEmailValid = (email = '') => EMAIL_REG_EXP.test(email);

export const isPhoneValid = (phone = '') => PHONE_REG_EXP.test(phone);
